import { Size } from 'const'
import { useLoginCallbackHook } from 'hooks'
import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import AccountIcon from 'assets/svg/top_menu/account.svg'
import NinaruIcon from 'assets/svg/top_menu/ninaru.svg'
import WebShopIcon from 'assets/svg/top_menu/web_shop.svg'
import ShopIcon from 'assets/svg/top_menu/shop.svg'
import { Banner, Logout, MenuCollapse } from 'components/shard'

function TopMenu() {
  const history = useHistory()
  const { webShopMypageURL } = useLoginCallbackHook()

  return (
    <React.Fragment>
      <TopMenuWrapper>
        <TopMenuTitle>My TANAKAマイページ</TopMenuTitle>
        <TopMenuArea>
          <TopMenuBlockArea>
            <MenuCollapse
              onClick={() => history.push('/service')}
              icon={NinaruIcon}
              title="NINALの契約"
              description="クレジットカードの登録・変更はこちら"
              collapse={false}
            />
            <MenuCollapse
              onClick={() => history.push('/purchases/histories')}
              icon={ShopIcon}
              title="店で購入"
              collapse={false}
            />
            <MenuCollapse
              onClick={() => (window.location.href = webShopMypageURL)}
              icon={WebShopIcon}
              title={'ウェブショップで購入'}
              description={'クレジットカードの登録・変更はこちら'}
              collapse={false}
            />
            <MenuCollapse
              onClick={() => history.push('/account')}
              icon={AccountIcon}
              title={'アカウント設定'}
              collapse={false}
            />
          </TopMenuBlockArea>
        </TopMenuArea>
      </TopMenuWrapper>
      <Banner />
      <Logout />
    </React.Fragment>
  )
}

/* トップメニュー部分 */
const TopMenuWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr minmax(min-content, 1440px) 1fr;
  margin-bottom: 60px;
`
const TopMenuTitle = styled.div`
  grid-column: 2;
  padding-bottom: 30px;
  font-size: ${Size.FONT.HEADLINE.XL};
  display: flex;
  align-items: center;
  font-weight: 700;
`
const TopMenuArea = styled.div`
  grid-column: 2;
`
const TopMenuBlockArea = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`
export default TopMenu
